import React, { useState } from "react";
import { Formik } from "formik";
import { Button, Grid, FormControl, InputAdornment, InputLabel, OutlinedInput, CircularProgress, Select, MenuItem } from "@material-ui/core";
import { PollPanelStyle } from '../../../infrastructure/PollPanelStyle';


export const CreateNewQuestion = ({createQuestion,ID}) => {
    const classes = PollPanelStyle();
    const [isLoanding, setisLoanding] = useState(false);
    const [listResponse] = useState([]);



    return (
        <Formik

            initialValues={{
                pregunta: "",
                tipo: ""
                
            }}

            validate={(valores) => {

                let errores = {};

                if (!valores.pregunta) {
                    errores.pregunta = 'Por favor ingresa una pregunta valida'
                } else if (!/^[a-z0-9A-ZÀ-ÿ\s.?.¿./]{1,200}$/.test(valores.pregunta)) {
                    errores.pregunta = 'No se aceptan caracteres especiales ni números'
                }


                if (!valores.tipo) {
                    errores.tipo = 'Por favor selecciona el tipo'
                } else if (!/^[a-zA-ZÀ-ÿ\s]{1,40}$/.test(valores.tipo)) {
                    errores.tipo = 'No se aceptan caracteres especiales ni números'
                }


                return errores;

            }}

            onSubmit={(valores, { resetForm }) => {
                
                    setisLoanding(true)
                    const data = {
                        question: valores.pregunta,
                        type: valores.tipo,
                        answers: listResponse,
                       
                    }
                    
                    createQuestion(data)
                    valores.isLoading = true;
                    setTimeout(() => {
                        setisLoanding(false)
                    }, 2000);
    

                    resetForm();
                

              
            }}
        >
            {({ values, errors, touched, handleSubmit, handleChange, handleBlur }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} style={{ textAlign: "left" }}>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="pregunta">Pregunta</InputLabel>
                                <OutlinedInput
                                    id="pregunta"
                                    type="total"
                                    name='pregunta'
                                    defaultValue={values.pregunta}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    labelWidth={100}
                                    style={{borderRadius:'10px'}}
                                />
                            </FormControl>
                            {touched.pregunta && errors.pregunta && <div style={{ color: "red" }}>{errors.pregunta}</div>}
                        </Grid>
                        <Grid item xs={12} md={12} sm={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel htmlFor="tipo">Tipo</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="tipo"
                                    name="tipo"
                                    defaultValue={values.tipo}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Tipo"
                                    startAdornment={<InputAdornment position="start">-</InputAdornment>}
                                    style={{borderRadius:'10px'}}

                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value="A">Abierta</MenuItem>
                                    <MenuItem value="C">Cerrada</MenuItem>
                                </Select>
                            </FormControl>
                            {touched.tipo && errors.tipo && <div style={{ color: "red" }}>{errors.tipo}</div>}
                        </Grid>
                        
                    </Grid>

                    <div className={classes.wrapper}>
                        <Grid container justifyContent="center" style={{ marginTop: '10px' }}>
                            <Button
                                disabled={isLoanding}
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ textTransform: "none", width: "50%",borderRadius:'10px' }}
                            >
                                Crear 
                            </Button>
                        </Grid>
                        {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </div>
                </form>
            )}
        </Formik>
    );
}